import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {getCompanyCreatedAt} from '../../../store/data/company/companySelectors';
import {
  settingsAddSelectedCustomFieldIdsAction,
  settingsRemoveSelectedCustomFieldIdsAction,
} from '../../../store/panels/settings/settingsPanelActions';
import {
  getSettingsPanelResources,
  makeGetSettingsResourcesSelectedCustomFieldIds,
} from '../../../store/panels/settings/settingsPanelSelectors';
import {isSettingsResourcesCustomFieldsResource} from '../../../store/panels/settings/settingsPanelState';
import {navigateToLinkAction} from '../../../store/stateless/navigationActions';
import {CustomFieldsTable} from './customFieldsTable';

/*
 * Selectors.
 */

function makeGetCustomFieldIds() {
  return createSelector([getSettingsPanelResources], (settingsResources) => {
    if (!settingsResources || !isSettingsResourcesCustomFieldsResource(settingsResources)) {
      return [];
    }
    return settingsResources.customFieldIds ?? [];
  });
}

function makeGetCustomFieldLoadingStatus() {
  return createSelector([getSettingsPanelResources], (settingsResources) => {
    if (!settingsResources || !isSettingsResourcesCustomFieldsResource(settingsResources)) {
      return undefined;
    }
    return settingsResources.status;
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  customFieldIds: makeGetCustomFieldIds(),
  selectedCustomFieldIds: makeGetSettingsResourcesSelectedCustomFieldIds(),
  companyCreatedAt: getCompanyCreatedAt,
  loadingStatus: makeGetCustomFieldLoadingStatus(),
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  addSelectedCustomFieldIds: settingsAddSelectedCustomFieldIdsAction,
  removeSelectedCustomFieldIds: settingsRemoveSelectedCustomFieldIdsAction,
  navigateToLink: navigateToLinkAction,
}));

export const CustomFieldsTableContainer = connect(mapStateToProps, mapDispatchToProps)(CustomFieldsTable);
